import React from "react";
import { useHistory } from "react-router-dom";

import { useGenerals } from "../hooks/useGenerals";
import { TOTAL_REWARD_AMOUNT } from "../constants/constants";

import VestIcon from "../../../assets/vest.svg";
import EarnIcon from "../../../assets/earn.svg";
import StakeIcon from "../../../assets/stake.svg";
import StakedLine from "../img/staked-line.png";
import RiseArrow from "../img/arrow-rise.svg";
import FallenArrow from "../img/arrow-fallen.svg";
import { useTheme } from "@material-ui/core";

import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import { withStyles } from "@material-ui/core/styles";
import Button from "./Button";
import DoughnutChart from "./DoughnutChart";
import { usePools } from "../hooks/usePools";
import Spinner from "./Spinner";

const styles = (theme) => ({
  root: {
    flex: 1,
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    padding: "30px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      padding: "70px",
    },
    position: "relative",
  },
  stakingBoardContainer: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "1140px",
  },
  stakingBoardActionContainer: {
    alignItems: "center",
    width: "100%",

    display: "grid",
    gridTemplateColumns: "1fr",
    marginBottom: "30px",
    gridGap: "30px",
    "@media (min-width:730px)": {
      gridTemplateColumns: "1fr 1fr",
      marginBottom: "24px",
      gridGap: "24px",
    },

    "@media (min-width:965px)": {
      gridTemplateColumns: "1fr 1fr 1fr",
      marginBottom: "32px",
      gridGap: "32px",
    },
  },
  stakingBoardAnalyseContainer: {
    fontFamily: "Poppins",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    color: theme?.colors?.home?.infoBoxBackground,
    boxShadow: "0px 10px 60px " + theme?.colors?.containerShadow,
    borderRadius: "32px",
    padding: "32px",
    backgroundColor: theme?.colors?.home?.summaryContainer,

    "& > *": {
      width: "100%",
    },

    "@media (max-width:412px)": {
      padding: "24px 6px",
    },
  },
  stakingCard: {
    height: "100%",
    width: "100%",
  },
  stakingCardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",

    color: theme?.colors?.home?.infoBoxBackground,
    boxShadow: "0px 10px 60px " + theme?.colors?.containerShadow,
    borderRadius: "32px",
    padding: "32px",
    backgroundColor: theme?.colors?.home?.summaryContainer,
    gap: "22px",
  },
  stakingCardHeading: {
    textAlign: "center",
    letterSpacing: "0px",
    maxWidth: "258px",

    color: theme?.colors?.presale?.cardTitle,
    fontSize: "20px",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
      fontSize: "25px",
    },
  },
  stakingCardLogo: {
    width: "140px",
    height: "70px",
  },
  stakingCardLogoImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  stakingCardDescription: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  stakingCardDescriptionNormal: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  stakingCardDescriptionBold: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  stakingAnalyseCard: {
    alignItems: "center",

    display: "grid",
    gridTemplateColumns: "1fr",
    marginBottom: "24px",
    gridGap: "24px",
    "@media (min-width:730px)": {
      gridTemplateColumns: "1fr 1fr",
    },

    "@media (min-width:965px)": {
      gridTemplateColumns: "1fr 1fr 1fr",
      marginBottom: "32px",
      gridGap: "32px",
    },
  },
  stakingRewardsClaimed: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  stakingRewardsChart: {
    width: "250px",
    height: "250px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  stakingStakedAmount: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  stakingStakedInfo: {
    width: "300px",
    height: "250px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  stakingStakedText: {
    fontFamily: "Poppins",
    fontSize: "27px",
    fontWeight: "bold",
    letterSpacing: "0px",
    marginTop: "60px",
    color: theme?.colors?.presale?.cardTitle,
  },
  stakingStakedLine: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    width: "15rem",
    height: "9rem",
    objectFit: "contain",
  },
  stakingBuidlPrice: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    marginBottom: "auto",
  },
  stakingSpinnerBuidlPrice: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  stakingPriceValue: {
    fontFamily: "Poppins",
    fontSize: "33px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  stakingPriceText: {
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  stakingPriceChange24: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  stakingPriceUp: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: "#00b71c",
    marginRight: "5px",
  },
  stakingPriceDown: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: "#950200",
    marginRight: "5px",
  },
  stakingPriceLast24h: {
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  stakingPriceArrowIcon: {
    width: "20px",
    height: "20px",
    marginRight: "5px",
  },
  stakingBuidlLogoContainer: {
    marignTop: "2rem",
    width: "9rem",
    height: "9rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  stakingBuidlLogo: {
    width: "150px",
    height: "150px",
  },
});

const StakingBoard = ({ classes }) => {
  const theme = useTheme();
  const history = useHistory();
  const { generals } = useGenerals();
  const { buidlUsdcPool, buidlEthPool, buidlWEthAEROPool } = usePools();

  const onStakingIncome = () => {
    history.push("/staking/pools");
  };

  const onRewards = () => {
    history.push("/staking/rewards");
  };

  const onVest = () => {
    history.push("/staking/vesting");
  };

  return (
    <div className={classes.stakingBoardContainer}>
      <div className={classes.stakingBoardActionContainer}>
        <div className={classes.stakingCard}>
          <div className={classes.stakingCardContainer}>
            <div className={classes.stakingCardHeading}>STAKE</div>
            <div className={classes.stakingCardLogo}>
              <a
                href="https://docs.starter.xyz/overview/tiers-and-staking"
                target="_blank"
                rel="noopener noreferrer"
                title="Click to learn more"
              >
                <img
                  src={StakeIcon}
                  alt="income"
                  className={classes.stakingCardLogoImage}
                />
              </a>
            </div>
            <div className={classes.stakingCardDescription}>
              <span className={classes.stakingCardDescriptionNormal}>
                Stake to qualify for FCFS or Guaranteed Allocation
              </span>
            </div>
            <Button
              text="Staking Pools"
              onClick={() => {
                onStakingIncome();
              }}
            />
          </div>
        </div>
        <div className={classes.stakingCard}>
          <div className={classes.stakingCardContainer}>
            <div className={classes.stakingCardHeading}>EARN</div>
            <div className={classes.stakingCardLogo}>
              <a
                href="https://docs.starter.xyz/overview/staking-rewards"
                target="_blank"
                rel="noopener noreferrer"
                title="Click to learn more"
              >
                <img
                  src={EarnIcon}
                  alt="starter"
                  className={classes.stakingCardLogoImage}
                />
              </a>
            </div>
            <div className={classes.stakingCardDescription}>
              <span className={classes.stakingCardDescriptionNormal}>
                Claim
                <span className={classes.stakingCardDescriptionBold}>
                  {" "}
                  BUIDL{" "}
                </span>
                rewards for staking in pools
              </span>
            </div>
            <Button text="Claim Rewards" onClick={onRewards} />
          </div>
        </div>
        <div className={classes.stakingCard}>
          <div className={classes.stakingCardContainer}>
            <div className={classes.stakingCardHeading}>VEST</div>
            <div className={classes.stakingCardLogo}>
              <img
                src={VestIcon}
                alt="vesting"
                className={classes.stakingCardLogoImage}
              />
            </div>
            <div className={classes.stakingCardDescription}>
              <span className={classes.stakingCardDescriptionNormal}>
                View staking deposits and{" "}
                <span className={classes.stakingCardDescriptionBold}>
                  yield from
                </span>{" "}
                rewards.
                <div />
              </span>
            </div>
            <Button
              classes={{
                root: classes.poolButton,
                label: classes.buttonLabel,
              }}
              onClick={onVest}
              text="View Deposits"
            />
          </div>
        </div>
      </div>
      <div className={classes.stakingBoardAnalyseContainer}>
        <div style={{ width: "100%" }}>
          <div className={classes.stakingAnalyseCard}>
            <div className={classes.stakingRewardsClaimed}>
              <div className={classes.stakingCardHeading}>
                GLOBAL REWARDS ISSUED
              </div>
              <div className={classes.stakingRewardsChart}>
                <DoughnutChart
                  type="global"
                  label="Total distributed"
                  value={`${
                    (parseFloat(generals?.totalDistributed) || 0) / 1000
                  }k`}
                  scale={1}
                  percentageComplete={
                    (parseFloat(generals?.totalDistributed) || 0) /
                    TOTAL_REWARD_AMOUNT
                  }
                />
              </div>
            </div>
            <div className={classes.stakingStakedAmount}>
              <div className={classes.stakingCardHeading}>
                GLOBAL AMOUNT STAKED
              </div>
              <div className={classes.stakingStakedInfo}>
                {parseFloat(
                  buidlUsdcPool?.tvl?.toFixed(2) || "0"
                )?.toLocaleString() === "0" ? (
                  <Spinner strokeSize="6px" width="54px" height="54px" />
                ) : (
                  <>
                    <img
                      src={StakedLine}
                      alt="staked"
                      className={classes.stakingStakedLine}
                    />
                    <span className={classes.stakingStakedText}>
                      $
                      {parseFloat(
                        (
                          buidlUsdcPool?.tvl +
                          buidlEthPool?.tvl +
                          buidlWEthAEROPool?.tvl
                        )?.toFixed(2) || "0"
                      )?.toLocaleString()}
                    </span>
                  </>
                )}
              </div>
            </div>
            {!generals?.price ? (
              <div className={classes.stakingSpinnerBuidlPrice}>
                <Spinner strokeSize="6px" width="54px" height="54px" />
              </div>
            ) : (
              <div className={classes.stakingBuidlPrice}>
                <div className={classes.stakingCardHeading}>
                  ${generals?.price || "0"}
                </div>
                <div className={classes.stakingPriceText}>BUIDL Price</div>
                <div className={classes.stakingPriceChange24}>
                  {parseFloat(String(generals?.percent24 ?? 17.65)) > 0 ? (
                    <span className={classes.stakingPriceUp}>
                      <img
                        src={RiseArrow}
                        alt="rise"
                        className={classes.stakingPriceArrowIcon}
                      />{" "}
                      {(
                        parseFloat(String(generals?.percent24 ?? 17.65)) || 0
                      ).toFixed(2)}
                      %
                    </span>
                  ) : (
                    <span className={classes.stakingPriceDown}>
                      <img
                        src={FallenArrow}
                        alt="fallen"
                        className={classes.stakingPriceArrowIcon}
                      />{" "}
                      {(
                        parseFloat(String(generals?.percent24 ?? 17.65)) || 0
                      ).toFixed(2)}
                      %
                    </span>
                  )}
                  <span className={classes.stakingPriceLast24h}>last 24h</span>
                </div>
                <div className={classes.stakingBuidlLogoContainer}>
                  <img
                    src={theme.logoImage}
                    alt="logo"
                    className={classes.stakingBuidlLogo}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(StakingBoard)));
